import React from 'react';
import PropTypes from 'prop-types';
import { CustomizeHomePageDrawerWidget } from './CustomizeHomePageDrawerWidget';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';

const theme = createTheme('uhc', { enterpriseFont: true });

export const Widget = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <CustomizeHomePageDrawerWidget {...props} />
    </ThemeProvider>
  );
};

Widget.displayName = 'utility/CustomizeHomePageDrawerWidget';

Widget.propTypes = {
  data: PropTypes.shape({
    isFlyoutOpen: PropTypes.bool,
    setIsFlyoutOpen: PropTypes.func,
    user: PropTypes.shape({}),
    setWidgetTabsOrder: PropTypes.func.isRequired,
    setIsTabPreferencesLoading: PropTypes.func.isRequired,
  }),
  events: PropTypes.shape({}),
};

Widget.defaultProps = {
  data: {},
  events: null,
};
